import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { fetchYoutubeBroadcasts } from './api/fetch-youtube-broadcasts';
import { YOUTUBE_BROADCASTS_FILTERS_CONFIG } from './filters/youtube-broadcasts-filters-config';
import { YoutubeBroadcastsGridView } from './YoutubeBroadcastsGridView';
import { Station } from '@app/core/types/stations';

interface YoutubeBroadcastsListProps {
  station: Station;
}

/**
 * ListView-backed YouTube broadcasts browser for a station, filtered by a single calendar day.
 */
export function YoutubeBroadcastsList({ station }: YoutubeBroadcastsListProps) {
  const timezone = useTimezone();
  const listId = `youtube-broadcasts-${station.slug}`;

  const queryFn = async (params: ListViewQueryParams) => {
    return fetchYoutubeBroadcasts(station.id, params, timezone);
  };

  return (
    <ListView
      listId={listId}
      queryFn={queryFn}
      filters={YOUTUBE_BROADCASTS_FILTERS_CONFIG}
      ListComponent={YoutubeBroadcastsGridView}
      defaultPageSize={100}
      stickyFilters={false}
      showProgress
    />
  );
}
